import { useForm } from 'react-hook-form';
import PasswordInput from '../common/PasswordInput';
import { BtnPrimary } from '../common/Buttons';
import { changeAgentPassword } from '../../hooks/mutations';
import { IAgentBrand } from '../../types/agent';
import { useState } from 'react';
import { IBrand } from '../../types/brand';

interface ChangePasswordFormData {
  agentId: string;
  newPassword: string;
  brandId: string;
}

const ChangePassword: React.FC<{
  agentId: string;
  onSuccess?: (data: any) => void;
  onError?: (e: any) => void;
  agentBrands: IAgentBrand[];
  brandsData: IBrand[];
}> = ({ agentId, onSuccess, onError, agentBrands, brandsData }) => {
  const form = useForm<ChangePasswordFormData>();
  const [selectedBrand, setSelectedBrand] = useState<IAgentBrand | null>(null);

  const { mutate: changePassword, isPending } = changeAgentPassword({
    onSuccess: (data) => onSuccess?.(data),
    onError: (e) => onError?.(e),
  });

  const onSubmit = (data: ChangePasswordFormData) =>
    changePassword({
      ...data,
      agentId,
      brandId: selectedBrand?.brandId?._id || '',
    });

  const getBrandName = (brandId: string) => {
    return brandsData.find((brand) => brand._id === brandId)?.name;
  };

  const filteredAgentBrands = agentBrands.filter(
    (agentBrand) => agentBrand.agentId === agentId
  );

  const handleBrandSelection = (agentBrand: IAgentBrand) => {
    setSelectedBrand(agentBrand);
    form.reset(); // Reset form when switching brands
  };

  return (
    <div className="space-y-6">
      <div>
        <div className="space-y-3">
          {filteredAgentBrands.map((agentBrand) => (
            <label
              key={agentBrand.brandId}
              className="flex items-center space-x-3 cursor-pointer"
            >
              <input
                type="radio"
                name="selectedBrand"
                value={agentBrand.brandId}
                checked={selectedBrand?.brandId === agentBrand.brandId}
                onChange={() => handleBrandSelection(agentBrand)}
                className="w-4 h-4 text-blue-600"
              />
              <span className="text-sm font-medium">
                {getBrandName(agentBrand.brandId?._id)}
              </span>
            </label>
          ))}
        </div>
      </div>

      {selectedBrand && (
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          className="space-y-6 border-t pt-6"
        >
          <div>
            <h4 className="text-md font-medium mb-4">
              Change Password for: {getBrandName(selectedBrand.brandId?._id)}
            </h4>
          </div>

          <PasswordInput
            key="newPassword"
            name="newPassword"
            formObj={form}
            showPasswordOption
            validation={{
              required: 'New password is required',
            }}
            label="New Password"
            placeholder="Enter new password"
          />
          <div className="flex justify-end">
            <BtnPrimary disabled={isPending} type="submit">
              {isPending ? 'Changing...' : 'Change Password'}
            </BtnPrimary>
          </div>
        </form>
      )}

      {filteredAgentBrands.length === 0 && (
        <div className="text-center py-8 text-gray-500">
          No brands found for this agent.
        </div>
      )}
    </div>
  );
};

export default ChangePassword;
